<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="user-repwd">
		<div class="container">
			<div class="head">
				<h1>找回密码</h1>
				<ul>
					<li class="step1 active">验证账号</li>
					<li class="step2 active">选择找回方式</li>
					<li class="step3 active">填写验证码</li>
					<li class="step4 active">重设密码</li>
				</ul>
			</div>
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm">
				<el-form-item prop="password">
					<span class="label">新密码</span>
					<el-input v-model="groupForm.password" type="password" show-password autocomplete="off" />
				</el-form-item>
				<el-form-item prop="password_confirm">
					<span class="label">确认密码</span>
					<el-input v-model="groupForm.password_confirm" type="password" show-password autocomplete="off" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="submit" @click="submitForm(ruleFormRef)">确认修改</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { resetPwd } from '@/api/home'
	import { ElMessage,ElMessageBox } from 'element-plus';
	import { payHeader,payFooter } from 'landui-ui';
	
	const bgStatus = ref(true);
	const router = useRouter();
	const ruleFormRef = ref(null);
	const groupForm = ref({password:'',password_confirm:''});
	const repwdDatas = ref({});
	
	const passValidate = (rule, value, callback) => {
		var count = 0;
		if(/\d/.test(value)) count++
		if(/[a-z]/.test(value)) count++
		if(/[A-Z]/.test(value)) count++
		if(/[_。%#@]/.test(value)) count++
		if(count < 3) {
			callback(new Error('密码必须包含大写字母、小写字母、数字及特殊符号中至少三项'))
		} else {
			callback()
		}
	};
	const passValidate2 = (rule, value, callback) => {
		if (value === '') {
			callback(new Error('请再次填写新密码'))
		} else if(value !== groupForm.value.password){
			callback(new Error('两次填写的密码不一致'))
		} else {
			callback()
		}
	};
	const rules = reactive({
		password: [
			{ required: true, message: '长度8~16字符,包含大写字母、小写字母、数字及特殊符号中至少三项', trigger: 'blur' },
			{ min: 8,max:16, message: '长度8~16字符,包含大写字母、小写字母、数字及特殊符号中至少三项', trigger: 'blur' },
			{ validator: passValidate, trigger: 'blur' }
		],
		password_confirm: [
			{ required: true, message: '请再次填写新的登录密码', trigger: 'blur' },
			{ validator: passValidate2, trigger: 'blur' }
		]
	});
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				const param = groupForm.value;
				param['account'] = repwdDatas.value.account;
				resetPwd(param).then((res) => {
					if(res.code === 200){
						ElMessageBox.confirm(
						    res.msg,
						    '温馨提示',
						    {
						      confirmButtonText: '立即登录',
						      showCancelButton: false,
						      closeOnClickModal: false,
						      showClose:false,
						      type: 'success',
						    }
						)
						.then(() => {
							router.push({ path: '/login' })
						})
						.catch(() => {
							
						})
					}
					
				})
			} else {
			  return false;
			}
		});
	};
	
	onMounted(() => {
		repwdDatas.value = JSON.parse(localStorage.getItem('repwdData'));
	})
	
</script>
